// extracted by mini-css-extract-plugin
module.exports = {"screen":"WhatsappGroupScreen_screen__RTNkp","state":"WhatsappGroupScreen_state__1t_U6"};